<div class="{{styles.oy_tag}} {{styles[props.size]}}"><span class="{{styles.tagText}}">{{props.label}}</span> <i class="iconfont icon-chacha {{styles.icon}}"></i></div>


// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYTag/index.art